import { Controller } from "@hotwired/stimulus"
import { SIDE_FILTER_SELECTOR } from "@/lib/Listing/MobileFilterHelpers.js"
import { readFilterState, panelCount } from "@/lib/Listing/FilterCounts.js"

export default class extends Controller {
  static targets = ["totalBadge", "pillBadge", "pillChevron", "listBadge"]
  static values = { categoryMediums: Object }

  connect() {
    this.updateCounts()
  }

  updateCounts() {
    const form = this.element.querySelector(SIDE_FILTER_SELECTOR)
    if (!form) return

    const state = readFilterState(form)
    const count = (panel, options) => panelCount(panel, state, this.categoryMediumsValue, options)
    let total = 0

    this.pillBadgeTargets.forEach((badge) => {
      const panel = badge.dataset.panel
      const chevron = this.pillChevronTargets.find((el) => el.dataset.panel === panel)
      this.#setBadge(badge, chevron, count(panel))
      total += count(panel, { forTotal: true })
    })

    this.listBadgeTargets.forEach((badge) => {
      const badgeCount = count(badge.dataset.panel)
      badge.textContent = badgeCount || ""
      badge.classList.toggle("hidden", badgeCount === 0)
    })

    if (this.hasTotalBadgeTarget) {
      this.totalBadgeTarget.textContent = total
      this.totalBadgeTarget.classList.toggle("hidden", total === 0)
    }
  }

  #setBadge(badge, chevron, count) {
    const active = count > 0
    badge.textContent = active ? count : ""
    badge.classList.toggle("hidden", !active)
    chevron?.classList.toggle("hidden", active)
  }
}
